<script lang="ts" setup>
import { app } from '@/composition/app'
import { initiateCustomTags } from '@/helper/customCode.helper'
import { useGlobalStore } from '@/store/app'
import { setAppLoading } from '@ghl/clientportal-core'
import { UIContentWrap } from '@gohighlevel/ghl-ui'
import { defineAsyncComponent, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

const TopNavBarMobile = defineAsyncComponent(
  () => import('@/components/common/NavBar/mobile/TopNavBarMobile.vue')
)
const TopNavBar = defineAsyncComponent(
  () => import('@/components/common/NavBar/web/TopNavBar.vue')
)
const MobileSideNav = defineAsyncComponent(() => import('./MobileSideNav.vue'))
const LoginBanner = defineAsyncComponent(
  () => import('./mobile/LoginBanner.vue')
)

const appStore = useGlobalStore()
const isLoading = ref(true)
const route = useRoute()
async function initializeApp() {
  try {
    isLoading.value = true
    setAppLoading(true)
    app.createAppForLocation()

    initiateCustomTags(app.state.locationData)
    isLoading.value = false
  } catch (error) {
    console.error(error)
  }
}

onMounted(() => {
  initializeApp()
})
</script>

<template>
  <UIContentWrap
    :full-screen="true"
    class="outer-container max-h-screen w-full"
  >
    <TopNavBar v-if="!app.state.isMobile" />
    <Transition name="fade" appear>
      <TopNavBarMobile v-if="app.state.isMobile" />
    </Transition>
    <LoginBanner v-if="app.state.isMobile && appStore.shouldShowLoginBanner" />
    <MobileSideNav v-if="app.state.isMobile" :is-loading="isLoading" />
    <!-- <BottomNavBarMobile
      v-if="
        app.state.isMobile &&
        !GroupState.state.routesWithNoBottomNavbar.includes(route.name) &&
        !appStore.shouldShowLoginBanner
      "
      class="fixed bottom-0 z-50 flex w-full justify-center"
      :route-config="bottomNavBarRouteConfig"
    /> -->
    <div class="main-container-outer">
      <router-view />
    </div>
  </UIContentWrap>
</template>

<style scoped>
.main-container-outer {
  min-height: 100vh;
  width: 100%;
}
</style>
